import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import NosotrosSection from '../components/NosotrosSection';
import ProductsSection from '../components/ProductsSection';
import FeaturesSection from '../components/FeaturesSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage" style={{ background: '#000000', minHeight: '100vh' }}>
      <Header />
      <HeroSection />
      <NosotrosSection />
      <ProductsSection />
      <FeaturesSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
